import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { GoBack } from '../GoBack';
import { LoadingSpinner } from '../../../components/Common/LoadingSpinner';
import { STORE_AUTH } from '../../../constants';
import { AuthStore } from '../../../stores';

export function LoggedInRoute<T extends RouteComponentProps<{}>>(
  RouteComponent: React.ComponentType<T>
): React.SFC<T> {
  return inject(STORE_AUTH)(
    observer((props: T) => {
      const authStore = props[STORE_AUTH] as AuthStore;

      // Wait for "remembered" users to be logged-in, if needed
      if (!authStore.rememberedUserFetchDone) {
        return (
          <div className="app-loader-wrapper">
            <LoadingSpinner />
          </div>
        );
      }

      if (!authStore.currentUser) {
        // If the route gets loaded when we're not logged in, navigate back
        return <GoBack {...props} />;
      }

      return <RouteComponent {...props} />;
    })
  );
}



// WEBPACK FOOTER //
// ./src/app/containers/Utils/LoggedInRoute/index.tsx